import { Product } from '../interfaces/S1';
import axios from 'axios';

export const generateOpt = async (): Promise<string> => {
	const response = await axios.get('/api/v1/iam/otp', {});
	return response.data.data.id;
};

export const fetchProducts = async (orgId: String): Promise<Product[]> => {
	const response = await axios.get(`/api/v1/iam/users/orgs/${orgId}/solutions`);
	return response.data.data.solutions;
};
